import { useState, useEffect } from "react";
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { observer } from "mobx-react-lite";
import { StateService } from "../services/StateService";
import classNames from "classnames";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      alignItems: "center",
      justifyContent: "center",
    },
    timerCountBox: {
      borderRadius: '27px',
      background: `transparent`,
      backgroundSize: 'cover',
      paddingBottom: 40,
    },
    timerCount: {
      zIndex: 999,
    },
    joinText: {
      fontSize: 42,
      fontFamily: 'Gilroy-Regular, sans-serif',
      paddingBottom: 35,
      fontWeight: 400,
      marginBottom: 0,
      color: 'white',
    },
    paper: {
      textAlign: "center",
      background: "transparent",
      color: "white",
      fontWeight: 500,
      position: "relative",
      fontFamily: "Gilroy-Medium, sans-serif",
      fontSize: "55px",
    },
    dot: {
      position: "absolute",
      right: 0,
      top: "26%",
      fontSize: "36px",
      color: "#fff",
    },
    paperTime: {
      fontSize: "22px",
      fontWeight: 500,
      color: "#8D89A3",
    },
    mainContain: {
      justifyContent: "center",
    },
    timerMain: {
      position: "relative",
      padding: "1px 24px 1px 24px",
    },
    innerTimer: {
      border: "1px solid #545174",
      padding: "5px 12px 5px 12px",
      borderRadius: "27px",
      boxShadow: "0px 100px 90px 0px #22081F3C",

    }
  }),

);

interface BasicHeroSectionProps {
  countDownDate?: Date,
  width?: string,
  state: StateService,
  title: string
}

interface SplitDate {
  seconds: string;
  minutes: string;
  hours: string;
  days: string;
}



export const BasicHeroSection = observer((props: BasicHeroSectionProps) => {
  const classes = useStyles();
  const { countDownDate, title } = props;

  const [date, setDate] = useState<SplitDate>({
    seconds: "00",
    minutes: "00",
    hours: "00",
    days: "00",
  });

  const updateTimeDifference = (inputTime: Date | undefined) => {
    let now = new Date().getTime();
    if (!inputTime) {
      setDate({
        seconds: "00",
        minutes: "00",
        hours: "00",
        days: "00",
      });
    } else {
      let timeleft = new Date(inputTime).getTime() - now;
      if (timeleft <= 0) {
        setDate({
          seconds: "00",
          minutes: "00",
          hours: "00",
          days: "00",
        });
      } else {
        setDate({
          seconds: ("0" + Math.floor((timeleft % (1000 * 60)) / 1000)).slice(
            -2
          ),
          minutes: (
            "0" + Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60))
          ).slice(-2),
          hours: (
            "0" +
            Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
          ).slice(-2),
          days: ("0" + Math.floor(timeleft / (1000 * 60 * 60 * 24))).slice(-2),
        });
      }
    }
  };

  useEffect(() => {
    if (!countDownDate) {
      return;
    }
    updateTimeDifference(countDownDate);
    const interval = setInterval(() => {
      updateTimeDifference(countDownDate);
    }, 1000);
    return () => clearInterval(interval);
  }, [countDownDate]);

  return (
    <div className={classes.root}>
      <Grid container spacing={0} className={classes.mainContain}>
        <Grid item xs={8} className={classes.timerCount}>
          <Paper elevation={0} className={classes.timerCountBox}>
            <Typography gutterBottom variant="h5" component="h2" className={classes.joinText}>
              {title}
            </Typography>
            <Grid container spacing={0}>
            <Grid item xs={3}>
              <div className={classes.timerMain}>
              <div className={classes.innerTimer}>
              <Paper className={classes.paper} elevation={0}>
                {date.days}
              </Paper>
              <Paper
                className={classNames(classes.paper, classes.paperTime)}
                elevation={0} >
                Days
              </Paper>
              </div>
              <div className={classes.dot}>:</div>
              </div>
            </Grid>
            <Grid item xs={3}>
            <div className={classes.timerMain}>
              <div className={classes.innerTimer}>
              <Paper className={classes.paper} elevation={0}>
                {date.hours}
              </Paper>
              <Paper
                className={classNames(classes.paper, classes.paperTime)}
                elevation={0}
              >
                Hours
              </Paper>
              </div>
              <div className={classes.dot}>:</div>
              </div>
            </Grid>
            <Grid item xs={3}>
            <div className={classes.timerMain}>
              <div className={classes.innerTimer}>
              <Paper className={classes.paper} elevation={0}>
                {date.minutes}
                
              </Paper>
              <Paper
                className={classNames(classes.paper, classes.paperTime)}
                elevation={0}
              >
                Minutes
              </Paper>
              </div>
              <div className={classes.dot}>:</div>
              </div>
            </Grid>
            <Grid item xs={3}>
            <div className={classes.timerMain}>
              <div className={classes.innerTimer}>
              <Paper className={classes.paper} elevation={0}>
                {date.seconds}
              </Paper>
              <Paper
                className={classNames(classes.paper, classes.paperTime)}
                elevation={0}
              >
                Seconds
              </Paper>
              </div>
              </div>
            </Grid>
          </Grid>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
});
